export default __webpack_public_path__ + "static/BasierCircle-Bold-73a52fcda90dc568a5f52c79a25dc048.woff2";